// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/projects/project-templates/archive',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/archive.vue'),
        name: 'project-management.project-templates.archived-project-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-template.update-project-template',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/archive/[id].vue'),
                name: 'project-management.project-templates.view-archived-project-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-template.update-project-template',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/project-templates/bin',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/bin.vue'),
        name: 'project-management.project-templates.binned-project-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-template.archive-project-templates',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/bin/[id].vue'),
                name: 'project-management.project-templates.view-binned-project-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-template.archive-project-templates',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/project-templates',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/new.vue'),
        name: 'project-management.project-templates.search-project-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-template.view-project-templates',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/new.vue'),
                name: 'project-management.project-templates.create-project-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-template.create-project-template',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-templates" */ '@/pages/[organisation]/projects/project-templates/project-template/[id].vue'),
                name: 'project-management.project-templates.view-project-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-template.view-project-templates',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-templates" */ '@/pages/[organisation]/projects/project-templates/project-template/[id]/edit.vue'),
                name: 'project-management.project-templates.update-project-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-template.update-project-template',
                },
            },
        ],
    },
];
